export default class CSVHelper {

  /*
      CSV "showErrors=auto;zoomLevel=9;layerSidebarActive=false;legendActive=true;searchboxActive=true;"
      TO:  setupToken: {
             showErrors:"auto",
             zoomLevel:9
             ...
            }
   */
  static getObjectArrayFromCSV(sCSV) {
    let result = [];
    if (sCSV) {
      sCSV = sCSV.replaceAll("\n", "")
      let token = sCSV.split(";")

      token.forEach((e) => {
        let option = e.split("=")
        let val = option[1]

        if (val != "") {
          if (!isNaN(val)) {
            val = parseFloat(val)
          }

          switch (val) {
            case "true":
              val = true;
              break;
            case "false":
              val = false;
              break;
          }
        }

        result[option[0]] = val
      })
    }
    return result
  }

  // 'this is :parameter' => 'this is'
  static removeWordsWithColon(inputString) {
    if(inputString!=null){
      let words = inputString.split(/\s+/);
      let filteredWords = words.filter(word => !word.startsWith(':'));
      return filteredWords.join(' ');
    }
  }

  static removeTextBetweenDoublePipe(inputString) {
    // Regular expression to match text between ||
    const regex = /\|\|(.*?)\|\|/g;

    // Replace matched text with an empty string
    return inputString.replace(regex, '');
  }

  // 'key1=value1;key2=value2' => { key1: value1, key2: value2}
  static stringToObject(inputString) {
    let resultObject = null

    if (inputString) {
      resultObject = {};
      const keyValuePairs = inputString.split(';');

      keyValuePairs.forEach(pair => {
        const [key, value] = pair.split('=');
        resultObject[key.trim()] = value.trim();
      });
    }
    return resultObject;
  }

  // 'config1=value1,value2,value3;config2=value1,value2' => ['value1', 'value2', 'value3'] for configName
  static getConfigCSVAsArray(csvString, configName) {
    if (!csvString || typeof csvString !== 'string' ) {
      return null;
    }

    const configRegex = new RegExp(`${configName}=([^;]+)`);
    const match = csvString.match(configRegex);

    if (match) {
      const valuesString = match[1];
      const valuesArray = valuesString.split(',');

      // Trim whitespace from each value
      return valuesArray.map(value => value.trim());
    } else {
      return [];
    }
  }
}
